module.exports = function getResource(label, vars=[]) {
    const resources = {
        free: 'GRATUIT',
        biFreeShip: 'Les membres Beauty Insider profitent de la *livraison standard GRATUITE* sur toutes les commandes.',
        biFreeShipTest: `Votre commande est admissible à *${vars[0]}.*`,
        biFreeShipTestVar: 'Livraison standard GRATUITE'
    };

    return resources[label];
};
